import React from 'react';
import styles from './ProductHeader.module.scss';
import { IAlbum } from '@/data/models/album';
import { useTranslation } from 'react-i18next';
import { formatTitleVersions } from '../../../common/ProductUtilities';
import ChangeRequestCounter from '@/components/common/ChangeRequestCounter/ChangeRequestCounter';

type ProductHeaderInfoProps = {
  album: IAlbum;
  readonly: boolean;
  onEditProductClicked: () => void;
  changeRequestCounter?: number;
};

export default function ProductHeader({
  album,
  readonly,
  onEditProductClicked,
  changeRequestCounter,
}: ProductHeaderInfoProps) {
  const { t } = useTranslation();
  return (
    <div className={styles['product-header-info']}>
      <div>
        <h2 className={styles['header']}>
          {album.title}
          <span className="supplementary-info">
            {formatCombinedProductVersion(album)}
          </span>
        </h2>
        <h3 className={`supplementary-info ${styles['header-artist']}`}>
          {album.displayArtist}
        </h3>
      </div>
      <div className={styles['product-header-action']}>
        <button
          className={`btn btn-primary alt ${styles['edit-product-button']}`}
          onClick={onEditProductClicked}
        >
          {readonly ? (
            <>
              <i className="icon fas fa-list"></i>
              <span> {t('common.button.viewDetails')}</span>
            </>
          ) : (
            <>
              <i className="icon fas fa-pencil"></i>
              <span> {t('common.button.editDetails')}</span>
            </>
          )}
        </button>
        <span className={'padding-left-x1'}>
          <ChangeRequestCounter
            counter={changeRequestCounter}
          ></ChangeRequestCounter>
        </span>
      </div>
    </div>
  );
}

function formatCombinedProductVersion(album: IAlbum) {
  return formatTitleVersions(
    album.albumMetaData?.versions,
    album.albumMetaData?.exclusiveReleaseAccountName
  );
}
